import { ITradeComment } from '@shared/models';

export interface State {
  loading: boolean;
  data: ITradeComment[];
  error: string;
}

export const initialState: State = {
  loading: false,
  data: [],
  error: null
};
